import { ReactElement } from "react";

/* eslint-disable */
export const loop = (times: number, callback: (i: number) => ReactElement) => {
	return [...Array(times)].map((item: any, i: number) => callback(i));
};
/* eslint-enable */
